import React from 'react';
import { LegalFooter } from './LegalFooter';
import { useT } from '../lib/i18n';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function Rules() {
  const { t } = useT();
  return (
    <div className="grain min-h-screen flex flex-col bg-[#050510] text-white">
      <div className="flex-1 w-full max-w-4xl mx-auto px-6 py-12 relative">
        <Link to="/" className="inline-flex items-center gap-2 text-[#A0A0B0] hover:text-white transition-colors mb-8 font-bold text-sm bg-white/5 px-4 py-2 rounded-xl hover:bg-white/10">
          <ArrowLeft size={18} /> {t("back_home")}
        </Link>
        <h1 className="font-display text-4xl font-black text-[#00FFFF] mb-8">{t("rules_title")}</h1>
        <div className="space-y-6 text-[#A0A0B0] leading-relaxed text-sm sm:text-base">
           <p>{t("rules_intro")}</p>
           <h2 className="text-xl font-bold text-white mt-8 mb-4">{t("rules_h1")}</h2>
           <p>{t("rules_p1_1")}</p>
           <p>{t("rules_p1_2")}</p>
           <h2 className="text-xl font-bold text-white mt-8 mb-4">{t("rules_h2")}</h2>
           <ul className="list-disc pl-5 space-y-2 mt-2">
             <li><strong className="text-[#FFE800]">{t("rules_m1_t")}:</strong> {t("rules_m1_d")}</li>
             <li><strong className="text-[#FFE800]">{t("rules_m2_t")}:</strong> {t("rules_m2_d")}</li>
           </ul>
           <h2 className="text-xl font-bold text-white mt-8 mb-4">{t("rules_h3")}</h2>
           <p>{t("rules_p3")}</p>
           <h2 className="text-xl font-bold text-white mt-8 mb-4">{t("rules_h4")}</h2>
           <p>{t("rules_p4")}</p>
        </div>
      </div>
      <LegalFooter screen="ZASADY" />
    </div>
  );
}